import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary-50 to-background py-20 lg:py-12 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary rounded-full"></div>
        <div className="absolute bottom-20 right-10 w-24 h-24 bg-accent rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-secondary rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Content with Animation */}
          <div className="text-center lg:text-left opacity-0 animate-slide-in-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
              Transforming Ideas into
              <span className="text-primary block">Digital Excellence</span>
            </h1>

            <p className="text-xl text-text-secondary mb-8 max-w-2xl">
              At Zentirx Infotech, we craft innovative software solutions that drive business growth. 
              From web applications to mobile apps, we turn your vision into reality with cutting-edge 
              technology and expert craftsmanship.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link
                to="/Services"
                className="inline-flex items-center justify-center px-8 py-4 bg-primary text-white font-semibold rounded-lg hover:bg-primary-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                Explore Services
                <Icon name="ArrowRight" size={20} className="ml-2" />
              </Link>

              <Link
                to="/Portfolio"
                className="inline-flex items-center justify-center px-8 py-4 bg-surface text-primary border-2 border-primary font-semibold rounded-lg hover:bg-primary hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                View Portfolio
                <Icon name="ExternalLink" size={20} className="ml-2" />
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 flex flex-wrap items-center justify-center lg:justify-start gap-8 text-sm text-text-secondary">
              <div className="flex items-center">
                <Icon name="Users" size={20} className="mr-2 text-primary" />
                <span><b>19+</b> Happy Clients</span>
              </div>
              <div className="flex items-center">
                <Icon name="Award" size={20} className="mr-2 text-primary" />
                <span><b>32+</b> Projects Delivered</span>
              </div>
              <div className="flex items-center">
                <Icon name="Clock" size={20} className="mr-2 text-primary" />
                <span><b>3+</b> Years Experience</span>
              </div>
            </div>
          </div>

          {/* Hero Image with Right Slide-in Animation */}
          <div className="relative opacity-0 animate-slide-in-right">
            <div className="relative z-10">
              <Image
                src="/assets/images/hero-section.png"
                alt="Team collaboration and software development"
                className="w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl rotate-"
              />
            </div>

            {/* Floating Cards */}
            <div className="absolute -top-6 -left-6 bg-surface p-4 rounded-xl shadow-lg border border-border z-10">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-success-100 rounded-lg flex items-center justify-center">
                  <Icon name="Code" size={20} color="var(--color-success)" />
                </div>
                <div>
                  <p className="font-semibold text-text-primary">Clean Code</p>
                  <p className="text-sm text-text-secondary">Best Practices</p>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -right-6 bg-surface p-4 rounded-xl shadow-lg border border-border z-10">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center">
                  <Icon name="Zap" size={20} color="var(--color-accent)" />
                </div>
                <div>
                  <p className="font-semibold text-text-primary">Consistent</p>
                  <p className="text-sm text-text-secondary">On Time, Every Time</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Animation CSS */}
      <style>
        {`
          @keyframes slideInLeft {
            0% {
              opacity: 0;
              transform: translateX(-500px); /* Start from the left side, slightly inward */
            }
            100% {
              opacity: 1;
              transform: translateX(0); /* End at the normal position */
            }
          }
          .animate-slide-in-left {
            animation: slideInLeft 0.9s ease-out forwards;
          }

          @keyframes slideInRight {
            0% {
              opacity: 0;
              transform: translateX(500px); /* Start from the right side, slightly inward */
            }
            100% {
              opacity: 1;
              transform: translateX(0); /* End at the normal position */
            }
          }
          .animate-slide-in-right {
            animation: slideInRight 0.9s ease-out forwards;
          }
        `}
      </style>
    </section>
  );
};

export default HeroSection;